import apiInstance from '../utils/axiosConfig';

const StatisticsService = {
    // Récupérer les statistiques principales du dashboard
    getDashboardStats: async (startDate = null, endDate = null) => {
        try {
            const params = {};
            if (startDate) params.startDate = startDate;
            if (endDate) params.endDate = endDate;

            const response = await apiInstance.get('/statistics/dashboard-stats', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching dashboard stats:', error.response?.data || error.message);
            throw error;
        }
    },

    // Récupérer l'évolution des souscriptions
    getSubscriptionEvolution: async (startDate = null, endDate = null) => {
        try {
            const params = {};
            if (startDate) params.startDate = startDate;
            if (endDate) params.endDate = endDate;

            const response = await apiInstance.get('/statistics/subscription-evolution', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching subscription evolution:', error.response?.data || error.message);
            throw error;
        }
    },

    // Récupérer les revenus par jour
    getDailyRevenue: async (startDate = null, endDate = null) => {
        try {
            const params = {};
            if (startDate) params.startDate = startDate;
            if (endDate) params.endDate = endDate;

            const response = await apiInstance.get('/statistics/daily-revenue', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching daily revenue:', error.response?.data || error.message);
            throw error;
        }
    },

    // Récupérer la répartition des employés
    getProfessionalDistribution: async () => {
        try {
            const response = await apiInstance.get('/statistics/professional-distribution');
            return response.data;
        } catch (error) {
            console.error('Error fetching professional distribution:', error.response?.data || error.message);
            throw error;
        }
    },

    // Récupérer les activités récentes
    getRecentActivities: async (limit = 5) => {
        try {
            const response = await apiInstance.get('/statistics/recent-activities', {
                params: { limit }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching recent activities:', error.response?.data || error.message);
            throw error;
        }
    },

    // Récupérer toutes les données du dashboard en une seule requête
    getCompleteDashboardData: async (startDate = null, endDate = null) => {
        try {
            const params = {};
            if (startDate) params.startDate = startDate;
            if (endDate) params.endDate = endDate;

            const response = await apiInstance.get('/statistics/complete-dashboard', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching complete dashboard data:', error.response?.data || error.message);
            throw error;
        }
    },

    // Méthode utilitaire pour formater les dates au format YYYY-MM-DD
    formatDate: (date) => {
        if (!date) return null;
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    },

    // Méthode utilitaire pour calculer la période par défaut (7 derniers jours)
    getDefaultPeriod: () => {
        const endDate = new Date();
        const startDate = new Date();
        startDate.setDate(startDate.getDate() - 7);

        return {
            startDate: StatisticsService.formatDate(startDate),
            endDate: StatisticsService.formatDate(endDate)
        };
    },

    // Méthode utilitaire pour calculer la période des 30 derniers jours
    getLast30DaysPeriod: () => {
        const endDate = new Date();
        const startDate = new Date();
        startDate.setDate(startDate.getDate() - 30);

        return {
            startDate: StatisticsService.formatDate(startDate),
            endDate: StatisticsService.formatDate(endDate)
        };
    },

    // Méthode utilitaire pour calculer la période des 3 derniers mois
    getLast3MonthsPeriod: () => {
        const endDate = new Date();
        const startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 3);

        return {
            startDate: StatisticsService.formatDate(startDate),
            endDate: StatisticsService.formatDate(endDate)
        };
    }
};

export default StatisticsService;